<template>
  <div class="firstPageContent">
    <header class="clearfix header">
      <div class="header-logo">
        <logo />
      </div>
      <div id="menu_display" @click=" leftDownShow = !leftDownShow "></div>
    </header>
    <div class="left-down" v-show="leftDownShow">
      <nav class="classify-box">
        <ul class="classify">
          <li class="classify-list special active">
            <div class="specialNav active" title="专题"></div>
          </li>
        </ul>
      </nav>
      <div class="classify-content" style="display: block">
        <div class="classify-tool clearfix">
          <h3 class="classify-title">专题</h3>
          <a href="javascript:void(0);" class="clear-all" @click="clear"><span></span>重置</a>
        </div>
        <thematicList />
      </div>
    </div>
  </div>
</template>
<script>
import thematicList from "./thematic-map/thematicList.vue";
import logo from './thematic-map/Logo.vue'
export default {
  components: { thematicList, logo },
  data() {
    return {
        leftDownShow: true
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    clear(){
      EVENTHUB.fire('clearThematic')
    }
  },
};
</script>
<style lang="less" scoped>
.firstPageContent {
  position: absolute;
  z-index: 2;
  top: 20px;
  left: 20px;
  width: 340px;
  border-radius: 3px;
  background: #fff;
  box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.3);
  .header {
    position: relative;
    z-index: 1;
    padding: 10px 0;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    .header-logo {
      float: left;
      margin-top: 5px;
      margin-left: 18px;
      width: 276px;
      height: 24px;
      // background: url("./../../assets/default/img/indexImg.png") -669px 0 no-repeat;
    }
    #menu_display {
        float: right;
        margin-top: 8px;
        margin-right: 10px;
        width: 19px;
        height: 15px;
        border: none;
        background: url(./../../assets/default/img/indexImg.png) -324px 0 no-repeat;
        cursor: pointer;
    }
  }
  .clearfix:after,
  .clearfix:before {
    clear: both;
    display: table;
    content: "";
  }
  .left-down {
    position: relative;
    .classify-box {
      height: 500px;
      float: left;
      width: 58px;
      border-right: 1px solid #eee;
      background: #fff;
      .classify,
      .classify-list {
        position: relative;
      }
      .classify-list {
        display: block;
        width: 58px;
        height: 55px;
        cursor: pointer;
      }
      .collection.active,
      .place.active,
      .special.active {
        background: #337fe5;
      }
      .specialNav.active {
        position: absolute;
        top: 17px;
        left: 18px;
        width: 22px;
        height: 21px;
        background: url(./../../assets/default/img/indexImg.png) no-repeat;
        background-position: -407px 0;
      }
    }
    .classify-content {
      width: 80%;
      float: left;
      height: 500px;
      overflow: hidden;
      margin-left: 10px;
      background: #fff;
      .classify-tool {
        line-height: 55px;
        .classify-title {
          float: left;
          // color: #3b3b3b;
          // font-weight: 700;
          // font-size: 21px;
          color: #333;
          font-weight: 400;
          font-size: 17px;
        }
        .clear-all,
        .clear-search {
          float: right;
          margin-top: 10px;
          margin-right: 15px;
          padding-left: 22px;
          color: #3f88e7;
          line-height: 33px;
          font-size: 13px;
          font-style: italic;
        }
      }
    }
  }
}
</style>
